import liveTranscriptionAvailabilityFetchFailed, {
	type LiveTranscriptionAvailabilityFetchFailedAction,
} from '@Application/Beneficiaries/Interviews/LiveTranscription/Actions/liveTranscriptionAvailabilityFetchFailed';
import liveTranscriptionAvailabilityFetched, {
	type LiveTranscriptionAvailabilityFetchedAction,
	type LiveTranscriptionAvailabilityPayload,
} from '@Application/Beneficiaries/Interviews/LiveTranscription/Actions/liveTranscriptionAvailabilityFetched';
import type FetchLiveTranscriptionAvailability from '@Application/Beneficiaries/Interviews/LiveTranscription/Queries/FetchLiveTranscriptionAvailability';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import type * as React from 'react';
import parameters from '../../../../parameters';

type Actions = LiveTranscriptionAvailabilityFetchedAction | LiveTranscriptionAvailabilityFetchFailedAction;

/** Tells whether the live transcription is configured for this facility and interview kind. */
const fetchLiveTranscriptionAvailability = (query: FetchLiveTranscriptionAvailability) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<LiveTranscriptionAvailabilityPayload>(
				`${parameters.api.host}/api/facilities/${query.facilityId}/live-transcription?interviewKind=${query.interviewKind}`,
			);

			const action = liveTranscriptionAvailabilityFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = liveTranscriptionAvailabilityFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};

export default fetchLiveTranscriptionAvailability;
